// eslint-disable-next-line @typescript-eslint/ban-types
export type IResponseTypes = object | string | boolean
export interface IResponse<T extends IResponseTypes> {
  success: boolean
  message?: string
  data?: T | null
}
export const ResponseData = <T extends IResponseTypes>(response: IResponse<T> | null): T | null => {
  if (response && response.success && response.data) return response.data
  return null
}

export const WrapIResponse = <T extends IResponseTypes>(
  data: T | null,
  success?: boolean,
  message?: string,
): IResponse<T> => {
  return { data, success: success || !!data, message }
}
